<h1 class="webapp-title" #requisitos>{{sectionInfo.title}}</h1>
<h3 class="medium-gray-title">{{sectionInfo.subtitle}}</h3>

<mat-accordion class="list"> <!-- *ngIf="isProductIdActive(1)" -->
    
    <mat-expansion-panel *ngFor="let item of sectionInfo.array" id="noBordersPanel">
      <mat-expansion-panel-header  id="nopaddingPanel">
        <div class="item-title">
          <div class="item-name">{{item[sectionInfo.fieldForTitle]}}</div>
          <div class="item-footer">{{item[sectionInfo.fieldForSubTitle]}}</div>
        </div>
      </mat-expansion-panel-header>
      <!-- CONTENT -->
      <p>{{item[sectionInfo.fieldForContent]}}</p>
      <ul *ngIf="item.sublist">
          <li *ngFor="let ele of item.sublist">
            {{ele}}
          </li>
      </ul>
      <button *ngIf="item.button" mat-stroked-button color="primary" (click)="openPdf(item.buttonLink)">
        <i class="far fa-file-pdf"></i>
        {{item.button}}
      </button>

      <button *ngIf="item.callToActionButton" mat-stroked-button color="primary" (click)="openAction(item.callToActionLink)">
        <!-- <i class="far fa-file-pdf"></i> -->
        {{item.callToActionButton}}
      </button>

    </mat-expansion-panel>

  </mat-accordion>
